export default "__VITE_ASSET__BynGK7xE__"